import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId, WA_DEFAULT } from "@/lib/site";

export default function AdmissionCTA() {
  return (
    <section className="relative py-16 md:py-24" data-testid="admission-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] border border-amber-500/25 bg-gradient-to-br from-obsidian-card via-obsidian-elevated to-obsidian-card px-6 py-16 sm:px-12 sm:py-20 text-center">
            <div className="absolute inset-0 grid-lines opacity-60 [mask-image:radial-gradient(ellipse_at_center,black,transparent_75%)]" />
            <div className="absolute -top-32 left-1/2 h-72 w-[560px] -translate-x-1/2 rounded-full bg-amber-500/15 blur-[110px]" />

            <div className="relative">
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-amber-500" data-testid="admission-eyebrow">
                Admissions Open
              </p>
              <h2 className="mx-auto mt-5 max-w-3xl font-display text-2xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
                Ready to Start Your <span className="text-brand">Creative Journey?</span>
              </h2>
              <p className="mx-auto mt-6 max-w-2xl text-sm sm:text-base text-gray-400 leading-relaxed">
                Whether you're starting from zero or looking to improve your existing creative skills, Motion
                Mind Institute can help you take the next step.
              </p>
              <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                <button
                  onClick={() => scrollToId("#contact")}
                  className="group inline-flex items-center gap-2 rounded-full bg-amber-500 px-8 py-4 text-sm sm:text-base font-semibold text-obsidian hover:bg-amber-400 hover:shadow-glow-amber hover:-translate-y-0.5 transition-all duration-300"
                  data-testid="admission-enquire-button"
                >
                  Enquire Now
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </button>
                <a
                  href={WA_DEFAULT}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full border border-emerald-500/40 bg-emerald-500/[0.06] px-8 py-4 text-sm sm:text-base font-medium text-emerald-400 hover:bg-emerald-500/15 hover:-translate-y-0.5 transition-all duration-300"
                  data-testid="admission-whatsapp-button"
                >
                  <MessageCircle className="h-4 w-4" />
                  Chat on WhatsApp
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
